import { createContext } from "react";
import { ConfigDataType, UserDataType, AppConfigType, GlobalDataType, PresenceContextType, } from "./types";

// create context
const MyUserDataContext = createContext<UserDataType>({});
const ConfigContext = createContext<ConfigDataType>({});
const AppConfigContext = createContext<AppConfigType>({});
const GlobalDataContext = createContext<GlobalDataType>({});
const PresenceContext = createContext<PresenceContextType>({
    presenceData: {},
    getViewers: () => [],
    getViewerCount: () => 0,
    isUserViewing: () => false,
    allActiveUsers: [],
    getCurrentViewers: () => [],
    getCurrentViewerCount: () => 0,
});





export { MyUserDataContext, ConfigContext, AppConfigContext, GlobalDataContext, PresenceContext };